import React from 'react';
import moment from 'moment';

const display = (value) =>
  value === null || value === undefined || value === '' ? '—' : value;

const displayBool = (value, t) =>
  value === true || value === false
    ? value
      ? t('Yes')
      : t('No')
    : display(value);

const displayDate = (value) =>
  value && moment(value).isValid()
    ? moment(value).format('DD MMMM YYYY')
    : '—';

const fileLink = (url, name) =>
  url ? (
    <a href={url} target='_blank' rel='noreferrer'>
      {name || url}
    </a>
  ) : (
    '—'
  );

export const getProductViewSections = (t, item, { onlineBrands } = {}) => {
  if (!item?.id) {
    return [];
  }

  const brandFromList = onlineBrands?.find(
    (b) => String(b.value) === String(item.brand_id),
  );

  const brandLabel = item.brand_title
    ? display(item.brand_title)
    : brandFromList
      ? brandFromList.shopping_center_title
        ? `${brandFromList.title} (${brandFromList.shopping_center_title})`
        : brandFromList.title
      : item.brand_id
        ? display(item.brand_id)
        : '—';

  return [
    {
      title: t('Info'),
      fields: [
        { text: t('Titolo IT'), value: display(item.title_it) },
        { text: t('Titolo EN'), value: display(item.title_en) },
        { text: t('Titolo FR'), value: display(item.title_fr) },
      ],
    },
    {
      title: t('Date'),
      fields: [
        { text: t('Data inizio'), value: displayDate(item.date_from) },
        { text: t('Data fine'), value: displayDate(item.date_to) },
        {
          text: t('Data scadenza adesione'),
          value: displayDate(item.membership_expiration_date),
        },
      ],
    },
    {
      title: t('Descrizione'),
      fields: [
        { text: t('Descrizione IT'), value: display(item.description_it) },
        { text: t('Descrizione EN'), value: display(item.description_en) },
        { text: t('Descrizione FR'), value: display(item.description_fr) },
      ],
    },
    {
      title: t('Prezzo'),
      fields: [
        { text: t('Prezzo Retail'), value: display(item.price_retail) },
        { text: t('Prezzo Outlet'), value: display(item.outlet_price) },
        {
          text: t('Sconto % sul prezzo Retail'),
          value: display(item.discount),
        },
        {
          text: t('Sconto % sul prezzo Outlet'),
          value: display(item.outlet_discount_price),
        },
        { text: t('Prezzo Finale'), value: display(item.final_price) },
        {
          text: t('Prezzo nascosto'),
          value: displayBool(item.hide_price, t),
        },
      ],
    },
    {
      title: t('Opzioni'),
      fields: [
        { text: t('Idea regalo'), value: displayBool(item.gift_idea, t) },
        { text: t('Stato'), value: display(item.published) },
        { text: t('Retail approvato'), value: display(item.retail_approved) },
        {
          text: t('Marketing approvato'),
          value: display(item.marketing_approved),
        },
      ],
    },
    {
      title: t('Shop'),
      fields: [{ text: t('Insegna'), value: display(item.company) }],
    },
    {
      title: t('Brand'),
      fields: [{ text: t('Brand'), value: brandLabel }],
    },
    {
      title: t('CANALI DI COMUNICAZIONE'),
      fields: [
        {
          text: 'Uso Archivio (printers)',
          value: displayBool(item.is_archive, t),
        },
        {
          text: 'NEWSLETTER (newsletter)',
          value: displayBool(item.is_newsletter, t),
        },
        { text: 'RADIO VILLAGE (radio)', value: displayBool(item.is_radio, t) },
        { text: 'SOCIAL (social)', value: displayBool(item.is_social, t) },
        { text: 'WEB', value: displayBool(item.is_web, t) },
      ],
    },
    {
      title: t('Files'),
      fields: [
        {
          text: t('Immagine'),
          value: fileLink(item.allData?.image, item.allData?.image_name),
        },
        {
          text: t('Logo'),
          value: fileLink(item.allData?.logo, item.allData?.logo_name),
        },
        {
          text: t('Video clip'),
          value: fileLink(
            item.allData?.video_clip,
            item.allData?.video_clip_name,
          ),
        },
      ],
    },
  ];
};
